import dynamic from 'next/dynamic'

import Footer from 'components/Footer'

import Styled from './styled'

const ModalLogin = dynamic(() => import('components/Modal/ModalLogin'), { ssr: false })
const Header = dynamic(() => import('components/Header'), {
  loading: () => <div aria-hidden="true" style={{ height: 50 }} />,
})

export default function Layout({ children, needLogin = false }) {
  return (
    <Styled className="layout-component">
      <Header />
      {children}
      <Footer />

      <ModalLogin needLogin={needLogin} />
    </Styled>
  )
}
